import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { getImageBannerTemplate } from "@/assets/utilities/tinymce/shortcodes/templates";
import { parseToHtml } from "@/utility/parseToHtml";
import { convertAssetsPathToRelativeLinks } from "@/utility/convertAssetsPaths";

function serializeContent(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => serializeContent(item));
  } else {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      newObj[key] = serializeContent(obj[key]);
    });

    return newObj;
  }
}

function visualizeContent(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => visualizeContent(item));
  } else {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      newObj[key] = visualizeContent(obj[key]);
    });

    return newObj;
  }
}

const decodeFromImageBannerData = element => {
  if (!element) return {};

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editImageBannerConfig = (editor, shortcodeWrapper) => {
  let currentData = decodeFromImageBannerData(shortcodeWrapper.getAttribute("data-image-banner-data"));

  const imageBannerWindow = editor.windowManager.openUrl({
    title: "Image Banner",
    url: "/image-banner-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");

      // Convert image URLs to relative paths
      if (currentData.imageBanners) {
        currentData.imageBanners.forEach(imageBanner => {
          if (imageBanner.imageURL) {
            imageBanner.imageURL = convertAssetsPathToRelativeLinks(imageBanner.imageURL)?.body?.innerHTML;
          }
        });
      }

      const serializedData = serializeContent(currentData);
      const encodedData = btoa(unescape(encodeURIComponent(JSON.stringify(serializedData))));

      shortcodeWrapper.setAttribute("data-image-banner-data", encodedData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateImageBannerData") {
        currentData = message.data;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    const imageBannerShortcodeData = shortcodeWrapper.getAttribute("data-image-banner-data");
    const parsedData = JSON.parse(decodeURIComponent(escape(window.atob(imageBannerShortcodeData))));
    const content = visualizeContent(parsedData);

    imageBannerWindow.sendMessage({
      type: "sendData",
      data: content,
    });
  };
};

const imageBannerConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Image Banner",
    url: "/image-banner-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getImageBannerTemplate(currentData),
        "image-banner",
      );

      // Convert image URLs to relative paths
      if (currentData.imageBanners) {
        currentData.imageBanners.forEach(imageBanner => {
          if (imageBanner.imageURL) {
            imageBanner.imageURL = convertAssetsPathToRelativeLinks(imageBanner.imageURL)?.body?.innerHTML;
          }
        });
      }

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      const serializedData = serializeContent(currentData);
      const encodedData = btoa(unescape(encodeURIComponent(JSON.stringify(serializedData))));

      shortcodeWrapperEl.setAttribute("data-image-banner-data", encodedData);

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { imageBannerConfig, editImageBannerConfig };
